<template>
	<div @click="spin" class="splash" :class="{ 'splash--spinning': spinning }" id="splash">
		<div class="splash__main">
			<p class="splash__code" id="splash-code">{{ code }}</p>
			<div class="splash__logo"></div>
			<img class="splash__mo" src="../assets/mo.png"/>
		</div>
	</div>
</template>

<script>
import code from '../assets/code.md'
export default {
	computed: {
		code () {
			return code
		}
	},
	data () {
		return {
			spinning: false
		}
	},
	methods: {
		spin () {
			this.spinning = true
			setTimeout(() => {
				this.spinning = false
			}, 600)
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$color-brand: #3bd3b2;

@function svg-uri($svg) {
	$encoded: "";
	$slice: 2000;
	$index: 0;
	$loops: ceil(str-length($svg) / $slice);

	@for $i from 1 through $loops {
		$chunk: str-slice($svg, $index, $index + $slice - 1);
		$chunk: str-replace($chunk, '"', "'");
		$chunk: str-replace($chunk, "<", "%3C");
		$chunk: str-replace($chunk, ">", "%3E");
		$chunk: str-replace($chunk, "&", "%26");
		$chunk: str-replace($chunk, "#", "%23");
		$encoded: #{$encoded}#{$chunk};
		$index: $index + $slice;
	}

	@return url("data:image/svg+xml;charset=utf8,#{$encoded}");
}

@function str-replace($string, $search, $replace: "") {
	$index: str-index($string, $search);

	@if $index {
		@return str-slice($string, 1, $index - 1) + $replace +
			str-replace(
				str-slice($string, $index + str-length($search)),
				$search,
				$replace
			);
	}

	@return $string;
}

.splash {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);

	width: 33vmin;
	height: 33vmin;

	overflow: hidden;
	border: 20px solid lighten($color-brand, 25%);
	background-color: lighten($color-brand, 15%);
	border-radius: 50%;

	cursor: pointer;

	&__main {
		position: absolute;
		width: 100%;
		height: 100%;
		overflow: hidden;
		border-radius: 50%;
		transform-origin: 50% 50%;
		transition: transform 600ms;
	}

	&__code {
		width: 600%;
		display: inline-block;
		color: lighten($color-brand, 25%);
		letter-spacing: 1px;

		@keyframes code {
			0% {
				transform: translate3d(-66%, 0, 0);
			}
			100% {
				transform: translate3d(0, 0, 0);
			}
		}

		animation: 20s code infinite linear;
	}

	&__logo {
		position: absolute;
		top: 8%;
		left: 15%;

		width: 70%;
		height: 50%;

		background-image: svg-uri(
			'<svg xmlns="http://www.w3.org/2000/svg" width="467.4" height="318.813" baseProfile="tiny"><g fill="#FFF"><path d="M299.38 223.844L46.54 227.028l246.5 3.105"/><path d="M422.17 114.557l-45.102 46.28-15.934 16.422 13.514-108.117 2.426-19.41-12.88 14.722L273.21 168.44l12.41-99.297 2.427-19.41-12.88 14.722-90.984 103.985 12.412-99.297 2.426-19.408-12.88 14.72L95.2 168.387l1.36-10.2c.677-4.938 1.295-9.885 1.804-14.845.512-4.96.948-9.93 1.425-14.892l5.61-59.58 1.184-12.56-7.853 9.61-49.45 60.52L0 187.106l52.34-58.042L95.88 80.506l-7.265 46.548c-.76 4.93-1.56 9.853-2.284 14.785-.73 4.932-1.348 9.877-1.907 14.83l-1.732 14.854-1.853 14.838-2.427 19.408 12.88-14.72 90.988-103.986-12.412 99.297-2.426 19.41 12.88-14.72 90.984-103.986-12.412 99.296-2.426 19.41 12.88-14.72 90.985-103.987-13.058 104.48-15.2 15.666-22.493 23.192-11.24 11.602c-3.75 3.865-7.413 7.81-11.058 11.77l-3.992 4.34 4.125 4.118 11.904 11.88 11.813 11.97 23.63 23.938 8.677 8.79 1.53-12.255 14.425-115.396L382.1 165.5l42.715-48.49L467.4 68.4l-45.23 46.157zm-87.555 178.256l-14.952-15.146-11.814-11.97-7.646-7.862c2.34-2.533 4.665-5.076 6.95-7.66l10.713-12.09 21.416-24.19 6.05-6.84-10.718 85.758zM390.084 1.553L378.204 0l.985 38.694"/><path d="M456.773 221.862l-89.56 1.127-.693 8.07 89.232 1.122"/></g></svg>'
		);

		background-size: contain;
		background-position: center center;
		background-repeat: no-repeat;
	}

	&__mo {
		display: block;
		position: absolute;
		width: 50%;
		height: auto;
		bottom: 0;
		left: 25%;
		transform-origin: 50% 100%;
		transition: transform 500ms;
	}

	&:hover {
		.splash__mo {
			transform: scale(1.05);
		}
	}

	&.splash--spinning {
		@keyframes spinning {
			0% {
				transform: translate(-50%, -50%) rotate3d(0, 1, 0, 0);
			}
			50% {
				transform: translate(-50%, -50%) rotate3d(0, 1, 0, 90deg);
			}
			50.001% {
				transform: translate(-50%, -50%) rotate3d(0, 1, 0, 270deg);
			}
			100% {
				transform: translate(-50%, -50%) rotate3d(0, 1, 0, 360deg);
			}
		}
		animation: 500ms spinning linear 1;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Splash.vue